import type { GiftPassListRow, GiftPassSortOrder } from '../../api/gift-passes';
import { GiftCardsErrorBanner } from '../gift-cards/GiftCardsErrorBanner';
import { GiftCardsLoadingState } from '../gift-cards/GiftCardsLoadingState';

import { GiftPassCard } from './GiftPassCard';
import { GiftPassesEmptyState } from './GiftPassesEmptyState';
import { GiftPassesTable } from './GiftPassesTable';

export interface GiftPassesResultsBodyProps {
  rows: GiftPassListRow[];
  loading: boolean;
  error: string | null;
  search: string;
  filtered: boolean;
  order: GiftPassSortOrder;
  onOrderChange: (order: GiftPassSortOrder) => void;
}

/** Both the table and the cards render; the stylesheet picks one by width. */
export function GiftPassesResultsBody(props: GiftPassesResultsBodyProps) {
  const { rows, loading, error } = props;
  if (error) return <GiftCardsErrorBanner message={error} />;
  if (loading) return <GiftCardsLoadingState label="Loading gift passes" />;
  if (rows.length === 0) {
    return <GiftPassesEmptyState search={props.search} filtered={props.filtered} />;
  }
  return (
    <>
      <div className="gp-results-table">
        <GiftPassesTable rows={rows} order={props.order} onOrderChange={props.onOrderChange} />
      </div>
      <div className="gp-results-cards">
        {rows.map((row) => (
          <GiftPassCard key={row.id} row={row} />
        ))}
      </div>
    </>
  );
}
